import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, FormHelperText,
    useMediaQuery, Button,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { createMaterialEntry } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import MaterialTable from '../MasterTables/MaterialTbl/MaterialTable';
import { errorStyles } from '../../Utils/table';
import { selectFirm, selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';


const MaterialEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        locId: '',
        firmId: '',
        materialNm: '',
        desp: '',
        size: '',
        pkts: '',
        pktqty: '',
        totqty: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchLocationData());
    }, [dispatch]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: value.toUpperCase()
    //     });
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const upperValue = value.toUpperCase();

        // Update form data
        let updatedForm = {
            ...formData,
            [name]: upperValue
        };

        // Auto-calculate total qty when pkts or pktqty changes
        if (name === 'pkts' || name === 'pktqty') {
            const pkts = parseFloat(
                name === 'pkts' ? upperValue : formData.pkts
            ) || 0;
            const pktqty = parseFloat(
                name === 'pktqty' ? upperValue : formData.pktqty
            ) || 0;
            updatedForm.totqty = (pkts * pktqty).toFixed(2);
        }

        setFormData(updatedForm);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
        if (!formData.desp) newErrors.desp = 'Description is required';
        if (!formData.size) newErrors.size = 'Size is required';
        // if (!formData.pkts) newErrors.pkts = 'Per Packet Qty is required';
        // if (!formData.pktqty) newErrors.pkts = 'Packet Qty is required';
        // if (!formData.firmId) newErrors.firmId = 'Firm is required';
        if (!formData.locId) newErrors.locId = 'Location is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            const result = await dispatch(createMaterialEntry(formData)).unwrap();
            console.log('POST request successful!', result);
            alert("Material Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };


    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>


                                {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                }

                                {[
                                    { label: 'Material Name', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Per Packet Qty', name: 'pkts' },
                                    // { label: ' Packet Qty', name: 'pktqty' },
                                    // { label: 'Total Qty', name: 'totqty' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        //      inputProps={{ style: styled.input }}
                                                        inputProps={{
                                                            style: styled.input,
                                                            readOnly: field.name === 'totqty'   // 👈 makes Total Qty read-only
                                                        }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

                <MaterialTable />
            </div>
        </>
    );
}

export default MaterialEntry;
